export const DEFAULT_PRECISION = 9;
export const DEFAULT_MIN_PRECISION = 3;
export const DECIMAL_UNITS = 9;
